import React from 'react';
import { Link } from 'react-router';
import { FormattedPlural } from 'react-intl';

import { ListItem } from 'material-ui/List';
import ContextIconMenu from '../Common/ContextIconMenu';
import IconButton from 'material-ui/IconButton';

import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import ProgrammeIcon from 'material-ui/svg-icons/action/assignment';

import { statusColours } from '../../constants/ColourConstants';

import ProgrammeActions from '../../actions/ProgrammeActionCreator';

import ROLES from '../../constants/Roles';
import PropTypes from 'prop-types';

const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    menuItem: {
        color: '#CC0000',
    },
    iconButton: {
        marginRight: 0,
    },
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};

const getActions = ({id, name}) => [
    {
        key: `3_${id}`,
        link: `/dashboard/programme/${id}/edit`,
        label: 'Edit',
        icon: <EditIcon/>,
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        key: `4_${id}`,
        type: 'deleteDialog',
        dialogType: 'menu',
        value: id,
        title: 'Delete programme',
        deleteAction: ProgrammeActions.delete,
        message: (<span>Are you sure to delete the programme  "{name}" ?</span>),
        condition: {
            roles: [ROLES.ADMIN]
        }
    }
];

const ProgrammeListItem = ({data}) => {
    const infoLink = `/dashboard/programme/${data.id}`;

    return (
        <ListItem
            style={style.listItem}
            leftAvatar={
                <Link to={infoLink}>
                    <ProgrammeIcon
                        style={style.icon}
                        color={data.courses > 0 ? statusColours.primary : statusColours.disabled} />
                </Link>
            }
            primaryText={<Link to={infoLink} className="primaryText">{data.name}</Link>}
            secondaryText={
                <Link to={infoLink} className="secondaryText">
                    <em>{(data.description || 'Programme')}</em><br/>
                    {data.courses}&nbsp;<FormattedPlural value={data.courses || 0} one='course' other='courses' />
                </Link>
            }
            secondaryTextLines={2}
            rightIcon={
                <ContextIconMenu
                    actions={getActions(data)}
                    data={data}
                    menuStyle={style.menu}
                    anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                    targetOrigin={{horizontal: 'right', vertical: 'top'}}
                    iconButtonElement={
                        <IconButton
                            touch={true}
                        >
                            <MoreVertIcon
                                color={statusColours.light}
                                style={style.iconButton}
                            />
                        </IconButton>
                    }
                />
            }
        />
    )
};


ProgrammeListItem.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default ProgrammeListItem;
